module.exports = __webpack_public_path__ + "img/stitcher.6b0ecac8.jpg";